module.exports = __webpack_public_path__ + "static/media/MsGladysOon.e717918c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub2/MsGladysOon.jpg
// module id = 209
// module chunks = 0